export default function LoadingProgress(props) {

    return (
        <div className="grid place-items-center h-screen">
            Loading
            {/*<img src="/images/loading.gif" width="115" height="115" alt="" />*/}
        </div>
    )
}